<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class CarBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: () => {}}) product

        get items() {
            const getSearchPageLabel = () =>
                `${carsRentRuntimeStore.pickUpPoint.name}, ${carsRentRuntimeStore.pickUpPoint.countryName} - ${carsRentRuntimeStore.dropOffPoint.name}, ${carsRentRuntimeStore.dropOffPoint.countryName}`
            const addSearchPageLink = items => {
                items.push({
                    title: getSearchPageLabel(),
                    to: carsRentRuntimeStore.searchPageLink(this.searchRequest),
                    exact: true,
                })
            }
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'carsRent':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'carBooking':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info.modelName,
                        disabled: true,
                    })
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'carConfirmation':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info.modelName,
                        disabled: true,
                    })
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(CarBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
